import { DownloadOutlined } from "@ant-design/icons";
import { ReactElement } from "react";
import { useParams } from "react-router-dom";
import { useGetApplicationDataToBankQuery } from "../../../../../store/api/applicationBankApi/applicationBank.api";
import { DownloadingFiles } from "../../../../../utils/utilities/Downloads";
import { TagSign } from "../../ApplicationDetailsDocList/TagSign/TagSign";

import classes from "./OfferDocuments.module.css";

export function OfferDocuments(): ReactElement {
  const { applicationBankId, applicationId } = useParams();
  const { data: applicationBank } = useGetApplicationDataToBankQuery({
    applicationBankId: Number(applicationBankId),
    applicationId: Number(applicationId),
  });

  const offerDocuments = applicationBank?.offer;

  function handleDownloadDocument({
    applicationBankId,
    fileId,
    fileName,
  }: {
    applicationBankId: number;
    fileId: number;
    fileName: string;
  }) {
    DownloadingFiles({
      url: `auth/applications/system-bank/create-data-to-bank/${applicationBankId}/file/${fileId}`,
      fileName: `${fileName}`,
    });
  }

  return (
    <>
      {offerDocuments?.map((offerDocument) => {
        return (
          <div key={offerDocument.id} className={classes.cardWrapper}>
            <div className={classes.cardHeader}>
              <div className={classes.cardTitle}>{offerDocument.name}</div>
              <div className={classes.buttonsWrapper}>
                {offerDocument.document && (
                  <>
                    <TagSign
                      tag={
                        offerDocument.document?.sign_file?.length
                          ? "sign_true"
                          : "sign_false"
                      }
                    />
                    <DownloadOutlined
                      className={classes.downloadButton}
                      onClick={() =>
                        handleDownloadDocument({
                          applicationBankId: Number(applicationBankId),
                          fileId: Number(offerDocument.document?.id),
                          fileName: offerDocument.document?.name || "default",
                        })
                      }
                    />
                  </>
                )}
              </div>
            </div>

            <div className={classes.documentList}>
              {Array.isArray(offerDocument.document) &&
                offerDocument.document?.map((document) => {
                  return (
                    <div
                      key={document.id}
                      className={classes.documentRow}
                      onClick={() =>
                        handleDownloadDocument({
                          applicationBankId: Number(applicationBankId),
                          fileId: document.id,
                          fileName: document.name,
                        })
                      }
                    ></div>
                  );
                })}
            </div>
          </div>
        );
      })}
    </>
  );
}
